import { render, staticRenderFns } from "./LdPopup.vue?vue&type=template&id=54a485a4&scoped=true&"
import script from "./LdPopup.vue?vue&type=script&lang=js&"
export * from "./LdPopup.vue?vue&type=script&lang=js&"
import style0 from "./LdPopup.vue?vue&type=style&index=0&id=54a485a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a485a4",
  null
  
)

export default component.exports